// Slot machine — shared payout logic used by both backends + the client. The
// SPIN OUTCOME is computed server-side (weighted reels, atomic wallet) so it can't
// be cheated; the client only renders what the server returns and shows the table.
//
// Rules (3 reels): three-of-a-kind pays the symbol's `three` multiplier; any other
// matching pair pays PAIR_MULT; otherwise nothing. Weighted so the long-run return
// is ~0.85 (a fly sink with a house edge), while pairs keep most spins lively.

export const SYMBOLS = [
  { id: "cherry", emoji: "🍒", weight: 30, three: 3 },
  { id: "fly", emoji: "🐛", weight: 25, three: 5 },
  { id: "egg", emoji: "🥚", weight: 18, three: 8 },
  { id: "lizard", emoji: "🦎", weight: 14, three: 14 },
  { id: "star", emoji: "⭐", weight: 9, three: 25 },
  { id: "diamond", emoji: "💎", weight: 4, three: 60 },
];

export const PAIR_MULT = 1.2; // any matching pair (not a triple)
export const MIN_BET = 5;
export const MAX_BET = 1000;
export const REELS = 3;

const TOTAL_WEIGHT = SYMBOLS.reduce((s, x) => s + x.weight, 0);

// Weighted reel pick from a random number r in [0, 1). Pure/deterministic.
export function weightedReel(r) {
  let t = r * TOTAL_WEIGHT;
  for (let i = 0; i < SYMBOLS.length; i += 1) {
    t -= SYMBOLS[i].weight;
    if (t < 0) return i;
  }
  return SYMBOLS.length - 1;
}

// Payout multiplier for a finished spin (array of symbol indices).
export function spinMultiplier(reels) {
  const [a, b, c] = reels;
  if (a === b && b === c) return SYMBOLS[a].three;
  if (a === b || b === c || a === c) return PAIR_MULT;
  return 0;
}

// Flies won for a bet on a spin (floored to a whole number).
export function payoutFor(bet, reels) {
  return Math.floor(bet * spinMultiplier(reels));
}

// Clamp/validate a requested bet to a whole number within [MIN_BET, MAX_BET], or
// null if it isn't a positive number.
export function normalizeBet(raw) {
  const n = Math.floor(Number(raw));
  if (!Number.isFinite(n) || n < MIN_BET) return null;
  return Math.min(n, MAX_BET);
}
